import { Svg } from './svg'

export const ExternalIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 1C2.55228 1 3 1.44772 3 2V13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15
      14 15H3C1.89543 15 1 14.1046 1 13V2C1 1.44772 1.44772 1 2 1Z"
      fill="currentColor"
    />
    <path
      d="M14 10C13.4477 10 13 9.55229 13 9V4.41421L7.70711 9.70711C7.31658 10.0976 6.68342
      10.0976 6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289L11.5858 3H7C6.44772
      3 6 2.55228 6 2C6 1.44772 6.44772 1 7 1H15V9C15 9.55229 14.5523 10 14 10Z"
      fill="currentColor"
    />
  </Svg>
)
